/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../components";
import { images } from "../../config/images";
import { useLocation, useNavigate } from "react-router";
import { ArchiveUser } from "./ArchiveUser";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { SingleUserData } from "../../redux/Slice/Users/SingleUserSlice";
import { ReGeneratePassord } from "./ReGeneratePassword";
import { LableFromEnums } from "../../utilities";

const UserInfo = () => {
  const [regeneratePassword, setRegeneratePassword] = useState(false);
  const [archive, setArchive] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userId = useLocation().state;
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const data = useAppSelector((state) => state.singleUser.SingleUserDataList);
  const { UserRole, canDeleteSensitiveData, canViewSensitiveData } = useAppSelector((state) => state.verifiedUser);
  const canDelete = !(UserRole?.role?.name === "SUPER_ADMIN" && !canDeleteSensitiveData);
  const canEdit = !(UserRole?.role?.name === "SUPER_ADMIN" && !canViewSensitiveData);

  const handleEdit = () => {
    navigate("/update-user", { state: data?.id });
  };

  useEffect(() => {
    dispatch(SingleUserData(userId));
  }, []);

  return (
    <>
      {data && (
        <>
          <Container fluid className="g-0">
            <Card>
              <Card.Body>
                <div className="page-title align-items-center d-flex justify-content-between">
                  <Card.Title className="mb-0">User Information</Card.Title>
                  <ButtonGroup>
                    {canDelete && (
                      <Button
                        type="button"
                        bname="Archive"
                        onClick={() => setArchive(true)}
                        name="archive"
                        id="archive"
                        className="btn btn-light rounded-1 me-3"
                      ></Button>
                    )}
                    {canEdit && (
                      <Button
                        onClick={handleEdit}
                        type="button"
                        bname="Edit User"
                        name="edit-user"
                        id="edit-user"
                        className="btn btn-primary rounded-1"
                      ></Button>
                    )}
                  </ButtonGroup>
                </div>
                <Row>
                  <Col lg={"3"} className="g-0">
                    <div className="align-items-center d-flex flex-column left-user-pic pt-3">
                      <div className="user-img">
                        <img
                          src={
                            data?.userImage
                              ? data?.userImage
                              : images.imgupload.default
                          }
                          alt="user"
                          width="78"
                          height="78"
                          className="rounded-1 bg-dark"
                        />

                      </div>
                      <span className="badges badges-success bg-opacity-50 bg-primary fw-semibold mb-2 mt-3 rounded-pill text-nowrap">
                        {data?.userRole?.role?.displayName}
                      </span>
                      <div className="user-name">
                        <h5 className="fw-semibold">
                          {data?.firstName} {data?.lastName}{" "}
                          <small className="text-info">
                            {LableFromEnums(data?.gender, Enums)}
                          </small>
                        </h5>
                      </div>
                      {data?.userRole?.role?.displayName != "End User" && (
                        <Button
                          type="button"
                          bname="Re-Generate Password"
                          name="regeneratepassword"
                          id="regeneratepassword"
                          onClick={() => setRegeneratePassword(true)}
                          className="btn btn-primary rounded-1 mt-3"
                        ></Button>
                      )}
                    </div>
                  </Col>
                  <Col lg={"9"}>
                    <div className="right-user-information ps-5 pb-5">
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Mobile Number
                          </span>
                          <span className="user-info">
                            {data?.countryCode} {data?.phone}{" "}
                            {data?.isPhoneVerified && (
                              <span className="badges ms-3 rounded-pill text-success badges-success">
                                Verified
                              </span>
                            )}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Email Address
                          </span>
                          <span className="user-info">
                            {data?.email ? data?.email : "-"}
                            {data?.isEmailVerified && (
                              <span className="badges ms-3 rounded-pill text-success badges-success">
                                Verified
                              </span>
                            )}
                          </span>
                        </Col>
                      </Row>
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Aadhar number
                          </span>
                          <span className="user-info">
                            {data?.aadharNumber ? data?.aadharNumber : "-"}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Date of birth
                          </span>
                          <span className="user-info">
                            {data?.birthDate ? data?.birthDate : "-"}
                          </span>
                        </Col>
                      </Row>
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Address
                          </span>
                          <span className="user-info">
                            {data?.address?.addressLine1}{" "}
                            {data?.address?.addressLine2}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Landmark
                          </span>
                          <span className="user-info">
                            {data?.address?.landmark
                              ? data?.address?.landmark
                              : "-"}
                          </span>
                        </Col>
                      </Row>
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Pincode
                          </span>
                          <span className="user-info">
                            {data?.address?.pincode}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            City
                          </span>
                          <span className="user-info">
                            {data?.address?.city}
                          </span>
                        </Col>
                      </Row>
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            State
                          </span>
                          <span className="user-info">
                            {data?.address?.state}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Country
                          </span>
                          <span className="user-info">
                            {data?.address?.country}
                          </span>
                        </Col>
                      </Row>
                      {data?.userFacilities?.length ? (
                        <Row className="text-start row-mb">
                          <Col>
                            <span className="user-info-title text-info text-uppercase d-block mb-2">
                              Assigned Facilities
                            </span>
                            <span className="user-info">
                              {data?.userFacilities?.map((item, index) =>
                                index !== data?.userFacilities.length - 1
                                  ? `${item?.facility?.name}, `
                                  : item?.facility?.name
                              )}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Created by
                          </span>
                          <span className="user-info">
                            {data?.createdByUser?.firstName}{" "}
                            {data?.createdByUser?.lastName}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Created At
                          </span>
                          <span className="user-info">{data?.createdAt}</span>
                        </Col>
                      </Row>
                      <Row className="text-start row-mb">
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Updated By
                          </span>
                          <span className="user-info">
                            {data?.updatedByUser?.firstName}{" "}
                            {data?.updatedByUser?.lastName}
                          </span>
                        </Col>
                        <Col>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Updated at
                          </span>
                          <span className="user-info">{data?.updatedAt}</span>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
          <ReGeneratePassord
            regeneratePassword={regeneratePassword}
            setRegeneratePassword={setRegeneratePassword}
            id={data.id}
          />
          <ArchiveUser
            setArchive={setArchive}
            archive={archive}
            id={data?.id}
          />
        </>
      )}
    </>
  );
};

export { UserInfo };
